import React, { useEffect, useMemo, useState } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { useMutation, useUser } from "hooks";
import { mutationRedeemVoucherDeeplink } from "graph";
import Keyvisual from "common/Keyvisual";
import Loading from "common/Loading";
import RequestLoginModal from "common/RequestLoginModal";
import { useTranslation } from "react-i18next";
import { Alert, Button, Container, Row, Col } from "react-bootstrap";

export default function RedeemVoucherDeeplink() {
	const { t } = useTranslation("account");
	const { code } = useParams();
	const { search } = useLocation();
	const history = useHistory();
	const user = useUser();
	const [error, setError] = useState(null);
	const [showLogin, setShowLogin] = useState(false);

	const customerNumber = useMemo(() => {
		const params = new URLSearchParams(search);
		return params.get("customer_number") || null;
	}, [search]);

	const [doRedeem, { loading }] = useMutation(mutationRedeemVoucherDeeplink, {
		onError: (err) => {
			setError(err.message || t("voucher_deeplink.error_generic"));
		},
		onCompleted: () => {
			history.push("/warenkorb");
		},
	});

	useEffect(() => {
		if (!code) return;

		if (!user) {
			setShowLogin(true);
			return;
		}

		doRedeem({
			variables: {
				code,
				customerNumber,
			},
		});
	}, [code, customerNumber, user, doRedeem]);

	return (
		<>
			<Keyvisual title={t("voucher_deeplink.title")} />
			<Container className="my-5">
				<Row className="justify-content-center">
					<Col md={8} lg={6}>
						{!user && (
							<RequestLoginModal
								show={showLogin}
								handleClose={() => {
									setShowLogin(false);
									history.push("/");
								}}
							/>
						)}

						{loading && <Loading text={t("voucher_deeplink.redeeming")} />}

						{error && (
							<Alert variant="danger">
								<Alert.Heading>
									{t("voucher_deeplink.error_title")}
								</Alert.Heading>
								<p>{error}</p>
								<hr />
								<div className="d-flex justify-content-end">
									<Button
										variant="outline-danger"
										onClick={() => history.push("/")}
									>
										{t("voucher_deeplink.to_shop")}
									</Button>
								</div>
							</Alert>
						)}
					</Col>
				</Row>
			</Container>
		</>
	);
}
